import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Center, Flex, Spinner } from '@chakra-ui/react';
import { hasValue } from '@kcast-fe/core';
const LoaderFC = ({ label, isCenter, size, color = '{colors.btnPrimary}' }) => {
    const renderSpinner = () => (_jsxs(Flex, { flexDirection: 'column', alignItems: 'center', gap: '12px', children: [_jsx(Spinner, { size: size, color: color, animationDuration: '0.8s', "data-testid": 'Loader' }), hasValue(label) && _jsx(Box, { children: label })] }));
    return isCenter ? _jsx(Center, { h: '100%', children: renderSpinner() }) : renderSpinner();
};
export const Loader = memo(LoaderFC);
//# sourceMappingURL=Loader.js.map